// js
import React from 'react';
import PropTypes from 'prop-types';
import SecurityDetailPPTX from '../../../containers/analytics/pptx/SecurityDetailPPTX';


const SecurityNonCriticalAcceptableDetailPPTX = ({ data }) => {
  return (
    <SecurityDetailPPTX
      data={data}
      criticality='nonCritical'
      adequacy='acceptable'
    />
  );
};

SecurityNonCriticalAcceptableDetailPPTX.propTypes = {
  data: PropTypes.object
};

export default SecurityNonCriticalAcceptableDetailPPTX;



// WEBPACK FOOTER //
// ./src/components/analytics/pptx/SecurityNonCriticalAcceptableDetailPPTX.js